const fleetGridletContentVr = {
  bindings: {
    fleet: '<',
    dataLoading: '<',
    filter: '<',
  },
  templateUrl: '/modules/gridlets/dashboard/fleet-gridlet-content-vr/fleet-gridlet-content-vr.html',
};

angular
  .module('dashboardGridletDirectives')
  .component('fleetGridletContentVr', fleetGridletContentVr);
